import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ApiService } from 'src/app/Services/api.service';
import { CommonServices } from 'src/app/Services/common.service';
import { FileUploadService } from 'src/app/Services/file-upload.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';

@Component({
  selector: 'app-event-vehicle',
  templateUrl: './event-vehicle.component.html',
  styleUrls: ['./event-vehicle.component.css'],
})
export class EventVehicleComponent implements OnInit {

  public breadcrumbData = {
    "Information": "/organization/transport-manager/information",
    "Vendors": "/organization/transport-manager/information/vendor/view-vendor",
  };
  matFormSize = '13px';
  eventVehicelForm: FormGroup;
  formSubmit: boolean = false;
  isShowSimno = false;
  isShowVendorName = false;

  isLocationMandatory: boolean = false;

  public vehicleLocation = {};
  public fieldOptions = {
    model: [
      { name: "Hatchback", value: "Hatchback", capacity: 3, max: 3 },
      { name: "Sedan", value: "Sedan", capacity: 4, max: 4 },
      { name: "SUV", value: "SUV", capacity: 7, max: 7 },
      { name: "Van", value: "Van", capacity: 15, max: 15 },
      { name: "Bus", value: "Bus", capacity: 60, max: 60 },
      { name: "Auto", value: "Auto", capacity: 3, max: 3 },
      { name: "Load Vehicle", value: "loadVehicle", capacity: 2, max: 100 }
    ],
  };

  VendorInfos: any;
  imageData: any;
  fcImage: any;
  pucImage: any;
  insuranceImage: any;
  routerLinks: any;

  /* Branch field */
  public branchLists: any = [];
  public selectedBranch = [];
  @ViewChild('branchSearch') branchSearchTextBox: ElementRef;
  branchSearchChangeObserver: any;
  public enableBranchField: boolean = false;
  public branchSearchVal: any = '';

  /* Error object */
  public errorObject: any = {};

  //For status default select
  public statusSelected: any = true.toString();
  public vehStatus: any = '';
  //display remarks
  public showRemarks = false;
  //vehicle capacity
  public vehCapacity: any = {};
  fuelType: any;
  imageUrl: any;
  minDate: Date;
  constructor(
    public fb: FormBuilder,
    public api: ApiService,
    public swal: SweetAlert,
    public storage: StorageService,
    public router: Router,
    public file: FileUploadService,
    public comService: CommonServices,
  ) {

    this.VendorInfos = this.storage.get('vendorID_orgID');
    let vendorName = this.VendorInfos['vendorName'];
    if (vendorName) {
      vendorName = this.comService.strTruncate(vendorName, 13);
      this.breadcrumbData[vendorName] = "/organization/transport-manager/information/vendor/single-view-vendor/" + this.VendorInfos.vendorID;
    } else {
      this.breadcrumbData['Vendor'] = "/organization/transport-manager/information/vendor/single-view-vendor/" + this.VendorInfos.vendorID;
    }
    this.breadcrumbData['Vehicles'] = "/organization/transport-manager/information/vehicle/view-vehicle/" + this.VendorInfos.vendorID;
    this.breadcrumbData['Create Event Vehicle'] = '';

    this.routerLinks = `/organization/transport-manager/information/vehicle/view-vehicle/${this.VendorInfos.vendorID}`;
  }

  ngOnInit(): void {
    this.getVehCapacity();
    this.getBranchList();
    this.addFormLoad();
    // const today = new Date().toISOString().split('T')[0];
    // console.log("today?",today)
    // document.getElementById('rcExpiryDate').setAttribute('min', today);
    // const currentDate = new Date();
    this.minDate = new Date();
  }

  addFormLoad() {
    this.eventVehicelForm = new FormGroup({
      vehRegNo: new FormControl('', [Validators.required, Validators.pattern('[A-Z|a-z]{2}[0-9]{1,2}[A-Z|a-z]{0,2}[0-9]{4}')]),
      imei: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(50), Validators.pattern('^[0-9|a-z|A-Z]*$')]),
      model: new FormControl('', [Validators.required]),
      capacity: new FormControl('', [Validators.required, Validators.min(1), Validators.max(100)]),
      boxType: new FormControl('', [Validators.required]),
      branch: new FormControl('', [Validators.required]),
    });
  }

  _keyPress(event: any) {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  getLocation(obj) {
    // console.log(obj);
    this.vehicleLocation = { ...obj };
  }

  patchVehicleCapacity(e) {
    this.vehCapacity.filter((option) => {
      if (option.value == e.value) {
        this.eventVehicelForm.controls['capacity'].setValidators([Validators.required, Validators.min(1), Validators.max(option.max)])
        this.eventVehicelForm.controls['capacity'].patchValue(option.capacity);
      }
    })
    if (this.formSubmit) this.validation();
  }
  patchFuelType(e) {
  }
  typeChange(e) {
  }

  onChangeBoxType(e) {
    // console.log(e.value);
    this.isShowVendorName = false;
    this.isShowSimno = false;
    if (e.value == 'others') {
      this.eventVehicelForm.removeControl('simNo');
      this.eventVehicelForm.addControl('vendorName', new FormControl('', [Validators.required])); /* , [Validators.required])); */
      this.isShowVendorName = true;
    }
    if (e.value == 'G10 Gps Device') {
      this.eventVehicelForm.removeControl('vendorName');
      this.eventVehicelForm.addControl('simNo', new FormControl('', [Validators.required, Validators.minLength(10), Validators.maxLength(13)]));
      this.isShowSimno = true;
    }
    if (this.formSubmit) this.validation();
  }
  getVehCapacity() {
    this.api.transportManagerVehicleCapacity({}).then((res: any) => {
      if (res.status == 'success' && res.data.length > 0 && res.data[0].vehicleTypes.length > 0) {
        this.vehCapacity = res.data[0].vehicleTypes;
        this.fuelType = res.data[0].fuelType;
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  getBranchList(name?) {
    this.enableBranchField = false;
    this.branchLists = [];
    const obj = {};
    if (name) obj['branchName'] = name;

    this.api.transportManagerBranchList(obj).then((res: any) => {
      if (res.status == 'success') {
        if (res.data && res.data.length > 0) {
          res.data.filter(item => {
            try {
              if (item.branchName && item.branchID) {
                let branchObj = {
                  name: item.branchName,
                  value: item.branchID,
                };
                let pushObj: boolean = true;
                this.selectedBranch.map((item) => { if (item.value == branchObj.value) { pushObj = false; } });
                if (pushObj) this.branchLists.push(branchObj);

              }
            } catch (err) {
              console.log('branch', err);
            }
          });
          if (this.branchLists.length > 0) {
            this.branchSelectionResult([this.branchLists[0]?.value]);
            this.eventVehicelForm.controls.branch.setValue(this.branchLists[0]?.value);
          }
        }
      }
      setTimeout(() => { this.enableBranchField = true }, 200);
    }).catch((err) => {
      console.log(err);
    });
  }

  // search
  branchSearchChange(searchValue: string) {
    searchValue = searchValue.trim().replace(/[^a-zA-Z0-9-_&, ]/g, '');

    if (!this.branchSearchChangeObserver) {
      new Observable(observer => {
        this.branchSearchChangeObserver = observer;
      }).pipe(debounceTime(500)) // wait 300ms after the last event before emitting last event
        .pipe(distinctUntilChanged()) // only emit if value is different from previous value
        .subscribe((term: any) => {
          // your code here
          this.getBranchList(term);
        });
    }

    this.branchSearchChangeObserver.next(searchValue);
  }

  branchSelectionResult(value) {
    if (!Array.isArray(value)) value = [value];
    let result = [];
    let removedResult = [];
    for (let i = 0; i < value.length; i++) {
      let val = value[i];
      this.selectedBranch.map((item) => {
        if (item.value == val) {
          let valIndex = result.findIndex((e) => e.value == item.value);
          if (valIndex == -1) result.push(item);
        }
      })
      this.branchLists.map((veh) => {
        if (veh.value == val) {
          let valIndex = result.findIndex((e) => e.value == veh.value);
          if (valIndex == -1) result.push(veh);
        }
      })
    }
    this.selectedBranch.map((branch) => {
      if (!value.includes(branch.value)) {
        let pushObj: boolean = true;
        removedResult.map((e) => { if (e.value == branch.value) pushObj = false; });
        if (pushObj) removedResult.unshift(branch);
      }
    })
    this.enableBranchField = false;
    this.branchLists = [...removedResult, ...this.branchLists]
    this.enableBranchField = true;
    this.selectedBranch = [...result];
    if (this.branchSearchTextBox && this.branchSearchTextBox.nativeElement)
      this.branchSearchTextBox.nativeElement.value = '';
    this.clearDuplicates();
  }

  clearDuplicates() {
    let result = [];
    this.enableBranchField = false;
    this.branchLists.map((branchObj) => {

      let pushObj: boolean = true;
      this.selectedBranch.map((item) => { if (item.value == branchObj.value) pushObj = false; });
      if (pushObj) result.push(branchObj);

    });
    this.branchLists = [...result];
    this.enableBranchField = true;
  }

  clearBranchSearch(event) {
    this.branchSearchTextBox.nativeElement.value = '';
    this.getBranchList();
  }

  /* private getChangedProperties(): string[] {
    let changedProperties = [];
  
    Object.keys(this.addVehicelForm.controls).forEach((name) => {
      const currentControl = this.addVehicelForm.controls[name];
  
      if (currentControl.dirty) {
        changedProperties.push(name);
      }
    });
    
    return changedProperties;
  } */


  // check Error in form field
  public checkError = (controlName: string, errorName: string) => {
    return this.eventVehicelForm.controls[controlName].hasError(errorName);
  }

  validation() {
    this.errorObject = {};
    let fields = Object.keys(this.eventVehicelForm.controls);
    fields.map((field) => {
      if (this.checkError(field, 'required')) {
        this.errorObject[field] = field.charAt(0).toUpperCase() + field.slice(1).toLowerCase() + ' is required.';
        if (field == 'vehRegNo') this.errorObject[field] = 'Registration No is required';
        else if (field == 'imei') this.errorObject[field] = 'IMEI is required';
        else if (field == 'vehicleType') this.errorObject[field] = 'Vehicle Type is required';
        else if (field == 'chassisNo') this.errorObject[field] = 'Chassis No is required';
        else if (field == 'engineNo') this.errorObject[field] = 'Engine No is required';
        else if (field == 'fcExpiryDate') this.errorObject[field] = 'FC expiry date  is required';
        else if (field == 'pucExpiryDate') this.errorObject[field] = 'PUC expiry date is required';
        else if (field == 'routePermitCost') this.errorObject[field] = 'Route Permit Cost is required';
        else if (field == 'startDate') this.errorObject[field] = 'Start Date is required';
        else if (field == 'insuranceExpiryDate') this.errorObject[field] = 'Insurance expiry date is required';
        else if (field == 'rcNo') this.errorObject[field] = 'RC Book No is required';
        else if (field == 'rcStartDate') this.errorObject[field] = 'RC Start date is required';
        else if (field == 'rcExpiryDate') this.errorObject[field] = 'RC expiry date is required';
        else if (field == 'vehicleInfo') this.errorObject[field] = 'Vehicle Info is required';
        else if (field == 'boxType') this.errorObject[field] = 'Box type is required';
        else if (field == 'isActive') this.errorObject[field] = 'Status is required';
        else if (field == 'remarks') this.errorObject[field] = 'Remarks is required';
        else if (field == 'vendorName') this.errorObject[field] = 'Vendor Name is required';
        else if (field == 'simNo') this.errorObject[field] = 'SIM No is required';
        else if (field == 'roadTaxStatus') this.errorObject[field] = 'Road Tax Paid is required';
        else if (field == 'rcfile') this.errorObject[field] = 'RC File is required';
        else if (field == 'fuelType') this.errorObject[field] = 'Fuel type is required';
      }
      else if (field == 'vehRegNo') {
        if (this.checkError(field, 'pattern')) this.errorObject[field] = 'Registration No is Incorrect';
      } else if (field == 'imei' || field == 'chassisNo' || field == 'engineNo' || field == 'routePermitCost') {
        if (this.checkError(field, 'minlength')) {
          if (field == 'imei') this.errorObject[field] = "IMEI should be above 3 characters";
          else if (field == 'chassisNo') this.errorObject[field] = "Chassis No should be more than 17 characters";
          else if (field == 'engineNo') this.errorObject[field] = "Engine No should be more than 17 characters";
          else if (field == 'routePermitCost') this.errorObject[field] = "Route Permit Cost should be minimum than 4 digits";
        } else if (this.checkError(field, 'maxlength')) {
          if (field == 'imei') this.errorObject[field] = "IMEI should be less than 50 characters";
          else if (field == 'routePermitCost') this.errorObject[field] = "Route Permit Cost should be more than 7 digits";
        }
      } else if (field == 'capacity') {
        if (this.checkError(field, 'min')) this.errorObject[field] = "Minimum capacity is required";
        else if (this.checkError(field, 'max')) this.errorObject[field] = "Maximum capacity is reached";
      }
      else if (field == 'rcStartDate' || field == 'rcExpiryDate' || field == 'expiryDate' || field == 'startDate') {
        if (this.checkError(field, 'matDatepickerMin')) {
          if (field == 'startDate') this.errorObject[field] = 'Start Date is Invalid';
          else if (field == 'expiryDate') this.errorObject[field] = 'Expiry Date is Invalid';
          else if (field == 'rcStartDate') this.errorObject[field] = 'RC Start Date is Invalid';
          else if (field == 'rcExpiryDate') this.errorObject[field] = 'RC Expiry Date is Invalid';
        }
      }
    })
  }

  onSubmit() {
    this.formSubmit = true;
    this.validation();
    //console.log(this.getChangedProperties())
    if (!this.eventVehicelForm.valid) {
      return;
    }

    const obj = {
      orgID: this.storage.get('userInfo').orgID,
      vendorID: this.VendorInfos.vendorID,
    };
    //obj.rcfile = this.imageData; 

    let keys = Object.keys(this.eventVehicelForm.value);
    if (keys.length > 0) {
      for (let k = 0; k < keys.length; k++) {
        let key = keys[k];
        if (this.eventVehicelForm.value[key] != '' &&
          this.eventVehicelForm.value[key] != [] &&
          this.eventVehicelForm.value[key] != {}) {
          obj[key] = this.eventVehicelForm.value[key];
        }
      }
    }
    
    // if (obj['isActive']) obj['isActive'] = ();
    obj['isActive'] = true;
    this.api.transportManagerVehicleCreate(obj).then((res: any) => {
      if (res.status == 'success') {
        this.swal.swalFunction(res.status, res.status, res.message, 2000);
        this.router.navigate([this.routerLinks]);
      }
      if (res.status == 'failure') {
        this.swal.swalFunction('error', res.status, res.message, 3000);
      }
    }).catch((err) => {
      console.log(err);
    });
  }
}
